import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from './monitoring.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
    constructor(private readonly monitoringService: MonitoringService) {}

    handleError(error: Error): void {
        this.monitoringService.logException(error);
    }
}